const baseName = '/dashboard';

module.exports = {
  dashboard: baseName + '/dashboard',
  personal: baseName + '/personal'
};
